export default "__VITE_ASSET__B7QCGKE4__"